module.exports = __webpack_public_path__ + "img/feature-07.5e9cac2a.png";